import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=cb80eefc&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=cb80eefc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb80eefc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb80eefc')) {
      api.createRecord('cb80eefc', component.options)
    } else {
      api.reload('cb80eefc', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=cb80eefc&scoped=true&", function () {
      api.rerender('cb80eefc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8YQZm2NC2f3Pu/JS/teamMember.vue"
export default component.exports